<script>
export default {
  name: 'Button',
}
</script>

<script setup>
import { NodeViewWrapper, nodeViewProps, NodeViewContent } from "@tiptap/vue-3"
import { LinkIcon } from '@heroicons/vue/24/solid'
import EditButton  from "../../Modals/EditButton.vue"
import useNodeProps from "@/Composables/useNodeProps"
import EditableNodeWrapper from "../../Components/EditableNodeWrapper.vue"

const props = defineProps({
  ...nodeViewProps,
})

let { href, button, justify, target } = useNodeProps(props)
</script>

<template>
  <node-view-wrapper>
    <EditableNodeWrapper v-bind="props">
      <template #tools>
        <EditButton
          :deleteNode="deleteNode"
          v-model:href="href"
          v-model:button="button"
          v-model:justify="justify"
          v-model:target="target"
        />
        <div class="mx-2 pl-2 border-l text-xs flex items-center text-gray-400 underline" :class="{'!text-red-500 !no-underline': href === '' || href === null}">
          <LinkIcon class="w-3 h-3 mr-1"/>
          <a v-if="href !== '' && href !== null" :href="href" :target="target" >{{ href }}</a>
          <span v-else>{{ __('No Link provided') }}</span>
        </div>
      </template>
      <template #content>
        <div :class="['flex justify-' + (justify ? justify : 'start')]">
          <NodeViewContent
            class="focus:ring-primary relative inline-flex items-center"
            :class="
            {
              'text-white px-4 py-2 text-sm font-medium leading-5 cursor-pointer bg-indigo-600 border-indigo-600 rounded-md border': button === 'primary',
              'rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-5 text-gray-500': button === 'secondary'
            }"
          />
        </div>
      </template>
    </EditableNodeWrapper>
  </node-view-wrapper>
</template>
